import { createStyles } from "@mantine/emotion";

export const useStylesTabsTable = createStyles((theme) => ({
  tabsList: {
    ":before": {
      border: "none",
    },
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      marginBottom: theme.spacing.tabsTable.margin.bottom.tabsList,
    },
  },
  tab: {
    border: "none",
    fontSize: theme.spacing.tabsTable.fontSize.tab,
    opacity: "0.3",
    fontFamily: theme.headings.fontFamily.bold,
    fontWeight: "bold",
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      fontSize: theme.spacing.tabsTable.fontSize.tabMobile,
    },
    '&[data-active="true"]': {
      backgroundColor: theme.customBackgrounds.table,
      opacity: "1",
    },
  },
  selectWrap: {
    width: theme.spacing.tabsTable.width.selectWrap,
    justifyContent: theme.flex.justify.end,
    gap: theme.spacing.tabsTable.gap.selectWrap,
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      width: "100%",
      justifyContent: theme.flex.justify.between,
      gap: theme.spacing.tabsTable.gap.selectWrapMobile,
    },
  },
  select: {
    maxWidth: theme.spacing.tabsTable.width.select,
    width: "100%",
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      marginBottom: theme.spacing.tabsTable.margin.bottom.select,
    },
  },
}));
